import React from 'react';

import { Flex, Text } from '@mantine/core';
import { DroxyBoxedIcon } from 'components/Droxy/DroxyBoxedIcon';
import { StaticToolGroup } from 'shared/interfaces/tools/Tool';

interface StaticToolGroupPreviewProps {
  staticToolGroup: StaticToolGroup;
}

export function StaticToolGroupPreview({ staticToolGroup }: StaticToolGroupPreviewProps) {
  return (
    <Flex gap="md" align="center" p="md" pl={0}>
      <DroxyBoxedIcon icon={staticToolGroup.icon} hasBorder />
      <Flex direction="column" gap={2}>
        <Text size="xs" fw={600}>
          {staticToolGroup.displayName}
        </Text>
        <Text size="xs" c="dimmed">
          {staticToolGroup.displayDescription}
        </Text>
      </Flex>
    </Flex>
  );
}
